@if (showSpinner) {
  <div class="spinner-border loader alfalaval-blue-color spinner-center"></div>
}

<div class="container mt-4">
  <h3>Upload Items (Aura Marine)</h3>

  <div class="row">
    <div class="col-md-8">
      <div class="card">
        <div class="card-body">
          <!-- File Selection -->
          <div class="mb-3">
            <label for="fileInput" class="form-label">Select Excel File</label>
            <input
              type="file"
              class="form-control"
              id="fileInput"
              accept=".xlsx,.xls"
              (change)="onFileSelected($event)"
              [disabled]="showSpinner">
              <div class="form-text">Please select an Excel file (.xlsx or .xls)</div>
            </div>

            <!-- Selected File Display -->
            @if (selectedFile) {
              <div class="mb-3">
                <div class="alert alert-info">
                  <strong>Selected File:</strong> {{ selectedFile.name }}
                  <br>
                    <small>Size: {{ (selectedFile.size / 1024 / 1024).toFixed(2) }} MB</small>
                  </div>
                </div>
              }

              <!-- Upload Progress -->
              @if (uploadProgress > 0 && uploadProgress < 100) {
                <div class="mb-3">
                  <div class="progress">
                    <div
                      class="progress-bar progress-bar-striped progress-bar-animated"
                      role="progressbar"
                      [style.width.%]="uploadProgress"
                      [attr.aria-valuenow]="uploadProgress"
                      aria-valuemin="0"
                      aria-valuemax="100">
                      {{ uploadProgress }}%
                    </div>
                  </div>
                </div>
              }

              <!-- Action Buttons -->
              <div class="mb-3">
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm me-2"
                  (click)="uploadFile()"
                  [disabled]="!selectedFile || showSpinner">
                  @if (showSpinner) {
                    <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                  }
                  Upload File
                </button>

                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm"
                  (click)="clearFile()"
                  [disabled]="showSpinner">
                  Clear
                </button>
              </div>

              <!-- Success Message -->
              @if (uploadSuccess) {
                <div class="alert alert-success">
                  <i class="fas fa-check-circle me-2"></i>
                  {{ successMessage }}
                </div>
              }

              <!-- Error Message -->
              @if (error) {
                <div class="alert alert-danger">
                  <i class="fas fa-exclamation-triangle me-2"></i>
                  {{ errorMessage }}
                </div>
              }
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="card">
            <div class="card-header">
              <h5>Upload Instructions</h5>
            </div>
            <div class="card-body">
              <ul class="list-unstyled">
                <li class="mb-2">
                  <i class="fas fa-file-excel text-success me-2"></i>
                  Supported formats: .xlsx, .xls
                </li>
                <li class="mb-2">
                  <i class="fas fa-info-circle text-info me-2"></i>
                  Maximum file size: 10MB
                </li>
                <li class="mb-2">
                  <i class="fas fa-upload text-primary me-2"></i>
                  Click "Upload File" to send to server
                </li>
                <li class="mb-2">
                  <i class="fas fa-spinner text-warning me-2"></i>
                  Progress will be shown during upload
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>